import apiClient, {createApiClient} from "./http";
import {NginxDomainConf} from "../entities/NginxDomainConf";
import {ServiceInfo} from "../entities/ServiceInfo";
import {NginxLocationConf} from "../entities/NginxLocationConf";
import {Response} from "../entities/Response";
import {NginxGrayReleaseServer} from "../entities/NginxGrayReleaseServer";

interface UpdateConfRequest {
    domainName: string;
    locations: NginxLocationConf[];
    grayRelease?: boolean;
    grayReleaseIps?: string[];
}

export default class NginxService {

    static async listConfs(): Promise<NginxDomainConf[]> {
        const response = await apiClient.get('/service/nginx/conf/list');
        return response.data;
    }

    static async getConf(domainName: string): Promise<NginxDomainConf | null> {
        const request = { domainName };
        const response = await apiClient.post(`/service/nginx/conf/get`, request);
        return response.data;
    }

    static async getMainConf(): Promise<NginxDomainConf | null> {
        const response = await apiClient.get(`/service/nginx/conf/main/get`);
        return response.data;
    }

    static async updateConf(conf: UpdateConfRequest): Promise<Response<any>> {
        for (let i = 0; i < conf.locations.length; i++) {
            conf.locations[i].sequence = i + 1;
        }
        return await apiClient.post(`/service/nginx/conf/update`, conf);
    }

    static async updateMainConf(confContent: string) : Promise<Response<any>> {
        return await apiClient.post(`/service/nginx/conf/update/main`, { confContent: confContent });
    }

    static async previewConf(conf: UpdateConfRequest): Promise<string> {
        const response = await apiClient.post(`/service/nginx/conf/preview`, conf);
        return response.data;
    }

    static async listAppKeys(): Promise<ServiceInfo[]> {
        const response = await apiClient.get('/service/serviceInfo/list');
        return response.data;
    }

    static async createConf(newConf: { domainName: string, environment: string, cdnSite: boolean }): Promise<Response<any>> {
        const apiClient = createApiClient({ timeoutInMills: 15000 });
        return await apiClient.post('/service/nginx/conf/create', newConf);
    }

    static async listNginxGrayReleaseServers(request: { domainName: string }): Promise<NginxGrayReleaseServer[]> {
        const response = await apiClient.post('/service/nginx/conf/servers/grayRelease/list', request);
        return response.data;
    }

    static async grayRelease(request: { domainName: string, grayReleaseIps: string[] }): Promise<void> {
        await apiClient.post('/service/nginx/conf/grayRelease', request);
    }
}